import './chunk-1fafdf15.js';
import './helpers.js';
import './chunk-6985c8ce.js';
import './chunk-d0a313ea.js';
import './chunk-cdfca85b.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { S as Select } from './chunk-77ffdf8b.js';
export { S as BSelect } from './chunk-77ffdf8b.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Select);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/select.js
// module id = 70
// module chunks = 10